import { motion } from "framer-motion";
import { createStyledElement } from "../../../../utils/createStyledElement";
import { systemWhite, systemBlack, DEFAULT_HEADER_HEIGHT } from "../../constants";

export const HeaderContainer = createStyledElement("header", {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  background: systemWhite,
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: DEFAULT_HEADER_HEIGHT,
  padding: "10px clamp(16px, 4vw, 60px)",
  zIndex: 10,
  boxSizing: "border-box",
  gap: 12,
});

export const Image = createStyledElement("img", {
  width: "clamp(120px, 18vw, 191px)",
  height: "auto",
  maxHeight: 40,
  minWidth: 0,
});

export const HeaderText = createStyledElement("span", {
  font: '400 clamp(11px, 1.6vw, 14px)/1.3 "Roboto", sans-serif',
  color: systemBlack,
  cursor: "pointer",
  whiteSpace: "nowrap",
  flexShrink: 1,
});

export const RightPane = createStyledElement("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: "clamp(8px, 2vw, 20px)",
  minWidth: 0,
});

export const Dropdown = createStyledElement(
  "div",
  ({ $isLanguageMenuOpen }) => ({
    position: "relative",
    cursor: "pointer",
    font: '400 14px/24px "Roboto", sans-serif',
    color: systemBlack,
    padding: 12,
    borderRadius: 4,
    backgroundColor: $isLanguageMenuOpen ? "#F5F7FA" : systemWhite,
  }),
  ["$isLanguageMenuOpen"]
);

export const DropdownMenu = createStyledElement(motion.ul, {
  position: "absolute",
  top: "100%",
  left: 0,
  backgroundColor: systemWhite,
  boxShadow: "0 10px 50px 0 #122A6033",
  listStyle: "none",
  padding: 0,
  borderBottomLeftRadius: 4,
  borderBottomRightRadius: 4,
  zIndex: 100,
});

export const DropdownMenuItem = createStyledElement("li", {
  padding: "8px 20px",
  cursor: "pointer",
  font: '400 14px/24px "Roboto", sans-serif',
  color: systemBlack,
  margin: 0,
});

export const HeaderButtonsContainer = createStyledElement(motion.div, {
  display: "flex",
  gap: 20,
  alignItems: "center",
  justifyContent: "flex-end",
});
